export default "__VITE_ASSET__DgMhFPDx__"